import React, { useState } from "react";
import { connect } from "react-redux";
import { DateRangePicker } from "react-dates";
import Select from "react-select";

import { textTranslate } from "../../utils/i18n";

// React DateRangePicker
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";

import moment from "moment";
import "moment/locale/da";

import "./SelectDateComp.css";
const PeriodSelectorComp = ({ dateRange, setDateRange, language, defaultPeriodIndex = 1, onPresetChange }) => {
  const [selectOptions] = useState([
    {
      label: "lastHour",
      value: moment().subtract(1, "hours"),
    },
    {
      label: "latestDay",
      value: moment().subtract(1, "days"),
    },
    {
      label: "latestWeek",
      value: moment().subtract(1, "weeks"),
    },
    {
      label: "latestMonth",
      value: moment().subtract(1, "months"),
    },
    {
      label: "latestThreeMonths",
      value: moment().subtract(3, "months"),
    },
    { label: "customDateSelector", value: "custom" },
  ]);

  const [selectedPeriod, setSelectedPeriod] = useState(selectOptions[defaultPeriodIndex]);
  const [showCustomDateSelector, setShowCustomDateSelector] = useState(selectOptions[defaultPeriodIndex]?.value === 'custom');
  const [startDate, setStartDate] = useState(dateRange.start);
  const [endDate, setEndDate] = useState(dateRange.end);
  const [focusedInput, setFocusedInput] = useState(null);

  const handleSelectPeriod = (e) => {
    if (selectedPeriod.value !== e.value) {
      let isCustomDate = !!(e.value === "custom");
      if (isCustomDate) {
        setShowCustomDateSelector(isCustomDate);
        setSelectedPeriod(e);
        if (onPresetChange) onPresetChange(selectOptions.findIndex((o) => o.label === e.label));
      } else {
        const today = new Date();
        const idx = selectOptions.findIndex((o) => o.label === e.label);
        setShowCustomDateSelector(false);
        setSelectedPeriod(e);
        setStartDate(e.value);
        setEndDate(moment(today));
        setDateRange({ start: e.value, end: moment(today), periodIndex: idx });
      }
    }
  };

  const handleDateRangeSelect = ({ startDate, endDate }) => {
    const localStartDate = startDate ? moment(startDate).startOf("day") : null;
    const localEndDate = endDate ? moment(endDate).endOf("day") : null;
    setStartDate(localStartDate);
    setEndDate(localEndDate);
    if (startDate && endDate) setDateRange({ start: localStartDate, end: localEndDate });
  };
  moment.locale(language);
  return (
    <div className="d-block">
      <Select
        className="w-100"
        id="dateSelect"
        onChange={handleSelectPeriod}
        defaultValue={selectOptions[defaultPeriodIndex]}
        getOptionLabel={(option) => textTranslate(option.label)}
        options={selectOptions}
      />

      {showCustomDateSelector && (
        <DateRangePicker
          startDatePlaceholderText={startDate}
          endDatePlaceholderText={endDate}
          required={false}
          startDate={startDate} // momentPropTypes.momentObj or null,
          startDateId="startDateId"
          endDate={endDate} // momentPropTypes.momentObj or null,
          endDateId="endDateId"
          onDatesChange={({ startDate, endDate }) => handleDateRangeSelect({ startDate, endDate })}
          focusedInput={focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
          onFocusChange={(focusedInput) => setFocusedInput(focusedInput)}
          enableOutsideDays={true}
          anchorDirection="right"
          openDirection={"down"}
          numberOfMonths={2}
          small
          showDefaultInputIcon
          block
          isOutsideRange={(day) => moment(day).isAfter(moment())}
          renderDayContents={(day) => {
            day.local(language);
            return moment(day).format("D");
          }}
        />
      )}
    </div>
  );
};
const mapStateToProps = ({ i18nReducer, usersReducer }) => ({
  language: i18nReducer.language,
  ability: usersReducer.ability,
});

export default connect(mapStateToProps, null)(PeriodSelectorComp);
